import { UiButton, UiDrawer, UiProfileModel, UiTextBox, UiTextArea } from "..";
import UiWarningRating from "../uiWarning";
import { userIcon } from "../../assets/images";
import "./style.scss";
import { formatPhoneNumber } from "../../utils/appUtils";
import { WhatsAppOutlined, MailFilled, CheckOutlined } from "@ant-design/icons";

const SupportDrawer = ({
    openProfileView,
    handleProfileCancel,
    supportProfileData,
    activeTab,
    selectedPlatforms = [],
    setSelectedPlatforms,
    subject,
    setSubject,
    message,
    setMessage,
    handleSendMessage,
    ...drawerProps
}) => {
    const isSendDisabled = !subject?.trim() || !message?.trim();

    const togglePlatform = (platform) => {
        if (supportProfileData?.complaintStatus === 'COMPLETED') return;
        if (selectedPlatforms?.includes(platform)) {
            setSelectedPlatforms(selectedPlatforms?.filter(selectedPlatform => selectedPlatform !== platform));
        } else {
            setSelectedPlatforms([...selectedPlatforms, platform]);
        }
    };
    return (
        <UiDrawer
            open={openProfileView}
            onClose={handleProfileCancel}
            title="Support Message"
            width={600}
            {...drawerProps}
            footer={<>
                <div className="flexible-end">
                    <UiButton onClick={handleProfileCancel}>Close</UiButton>
                </div>
            </>}
        >
            <div className="support-information">
                <div className="flexible" style={{ borderBottom: "1px solid #000" }}>
                    <div className="flexible">
                        {
                            !supportProfileData?.profilePic || supportProfileData?.profilePic?.includes("null") || supportProfileData?.profilePic?.includes("undefined") ? <img src={userIcon} style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} alt="" /> : <UiProfileModel imageUrl={supportProfileData?.profilePic} />
                        }
                        <div>
                            <h3 className="supportInfo-detail">
                                {supportProfileData?.name || "Nil"}
                            </h3>
                            <UiWarningRating count={supportProfileData?.raisedByWarningCount} />
                        </div>
                    </div>
                    <div className="flexible">
                        <div>
                            <small className="information-header">
                                {activeTab === "CUSTOMERS" ? "Customer ID" : "Advocate ID"}</small>
                            <h3 className="supportInfo-detail">{supportProfileData?.raisedByNo || "Nil"}</h3>
                        </div>
                    </div>
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Mobile Number</small>
                        <h3 className="supportInfo-detail">
                            {supportProfileData?.mobileNumber ? formatPhoneNumber(supportProfileData?.mobileNumber) : "Nil"}
                        </h3>
                    </div>
                    <div>
                        <small className="information-header">E-mail Address</small>
                        <h3 className="supportInfo-detail">{supportProfileData?.email || "Nil"}</h3>
                    </div>
                </div>
            </div>
            <div className="support-details">
                <div className="flexible" style={{ borderBottom: "1px solid #00000054", paddingBottom: "10px", marginBottom: "10px", justifyContent: "space-between", gap: "10px" }}>
                    <h3 className="supportInfo-heading">Support</h3>
                    <h3 className="supportInfo-heading support-no-text">{supportProfileData?.supportNo || "Nil"}</h3>
                </div>
                <p className="support-message-text">
                    {supportProfileData?.description || "Nil"}
                </p>
            </div>
            <div style={{ marginTop: '20px' }}>
                <h3 className="supportInfo-heading" style={{ marginBottom: '10px', padding: '0 10px' }}>Select platform to Send Message</h3>
                <div className="flexible-start" style={{ gap: '15px' }}>
                    <div
                        className={`platform-card ${selectedPlatforms?.includes('whatsapp') ? 'selected' : ''}`}
                        onClick={() => togglePlatform('whatsapp')}
                        style={{ cursor: supportProfileData?.complaintStatus === 'COMPLETED' ? 'not-allowed' : 'pointer' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <WhatsAppOutlined style={{ color: '#25D366', fontSize: '20px' }} />
                            <span style={{ fontWeight: 500 }}>Whatsapp</span>
                        </div>
                        {selectedPlatforms?.includes('whatsapp') && <CheckOutlined style={{ color: '#25D366' }} />}
                    </div>
                    <div
                        className={`platform-card ${selectedPlatforms?.includes('email') ? 'selected' : ''}`}
                        onClick={() => togglePlatform('email')}
                        style={{ cursor: supportProfileData?.complaintStatus === 'COMPLETED' ? 'not-allowed' : 'pointer' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <MailFilled style={{ color: '#1890FF', fontSize: '20px' }} />
                            <span style={{ fontWeight: 500 }}>E-mail</span>
                        </div>
                        {selectedPlatforms?.includes('email') && <CheckOutlined style={{ color: '#1890FF' }} />}
                    </div>
                </div>
            </div>
            <div style={{ marginTop: '20px' }}>
                <h3 className="supportInfo-heading" style={{ marginBottom: '5px', padding: '0 10px' }}>Subject</h3>
                <UiTextBox
                    placeholder="Enter Subject"
                    value={subject}
                    onChange={(data) => setSubject(data?.target?.value)}
                    readOnly={supportProfileData?.complaintStatus === 'COMPLETED'}
                    maxLength={50}
                />
            </div>
            <div style={{ marginTop: '20px' }}>
                <h3 className="supportInfo-heading" style={{ marginBottom: '5px', padding: '0 10px' }}>type Support Message</h3>
                <UiTextArea
                    placeholder="Enter Support Message"
                    value={message}
                    onChange={(data) => setMessage(data?.target?.value)}
                    rows={6}
                    readOnly={supportProfileData?.complaintStatus === 'COMPLETED'}
                    maxLength={150}
                />
            </div>
            {supportProfileData?.complaintStatus !== 'COMPLETED' && (
                <div style={{ marginTop: '20px' }}>
                    <UiButton
                        className="send-support-btn"
                        style={{ width: '100%', backgroundColor: '#CDBA6D', color: 'white', border: 'none', height: '40px', fontSize: '16px' }}
                        disabled={isSendDisabled}
                        onClick={handleSendMessage}
                    >
                        Send Support Message
                    </UiButton>
                </div>
            )}
        </UiDrawer>
    );
};

export default SupportDrawer;
